// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Label } from "semantic-ui-react";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const Clock = ({ time = 0 }) => {
	const minutes = Math.floor(time / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);
	const hrs = hours - days * 24;
	const mins = minutes - days * 1440 - hrs * 60;
	const secs = time % 60;

	return (
		<div className={styles.container}>
			{days >= 1 && (
				<>
					<div className={styles.timeContainer}>
						<Label className={styles.clockItem} color="black">
							{days}
						</Label>
						<Text className={styles.clockText}>Días</Text>
					</div>
					<Text className={styles.doubleDots}>:</Text>
				</>
			)}
			<div className={styles.timeContainer}>
				<Label className={styles.clockItem} color="black">
					{hrs}
				</Label>
				<Text className={styles.clockText}>Horas</Text>
			</div>
			<Text className={styles.doubleDots}>:</Text>
			<div className={styles.timeContainer}>
				<Label className={styles.clockItem} color="black">
					{mins}
				</Label>
				<Text className={styles.clockText}>Minutos</Text>
			</div>
			<Text className={styles.doubleDots}>:</Text>
			<div className={styles.timeContainer}>
				<Label className={styles.clockItem} color="black">
					{secs}
				</Label>
				<Text className={styles.clockText}>Segundos</Text>
			</div>
		</div>
	);
};

Clock.propTypes = {
	time: PropTypes.number,
};

export default Clock;
